import { mapState, mapGetters } from 'vuex'
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';

export default {
  components: {
    marketCharts,
  },
  computed: {
    ...mapState('market', ['market']),
    ...mapGetters('app', ['isLayoutDesktop']),
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/pages/sushi-market-charts/sushi-market-charts.js